module.exports = __webpack_public_path__ + "img/227.3658894f.svg";